import React, { useState } from "react";
import { Card, Col, Flex, Form, Radio, Row, Switch, Tag, Select, Typography, Upload } from "antd";
import Input from "../../../../components/Input/Input";
import DatePicker, { TimePicker } from "../../../../components/DatePicker/DatePicker";
import dayjs, { Dayjs } from "dayjs";
import TextArea from "../../../../components/Input/TextArea";
import Text from "../../../../components/Text/Text";
import "./../../CODiscountClass.css";
import Button from "../../../../components/Button/Button";
import { color, icon } from "../../../../resource";
import { DeleteFilled } from "@ant-design/icons";
import { ModalPreviewFile, readFileAsBase64 } from "../../CODiscountComponent";

export const CODiscountStepOne: React.FC<{
  form1: any;
  form2: any;
  typeList: any[];
  fileRef: any;
  setFileRef: any;
}> = ({ form1, form2, typeList, fileRef, setFileRef }) => {
  const [fileBase64, setFileBase64] = useState<string | null>(null);
  const _watchCoId = Form.useWatch("coId", form1);
  const [openPdf, setOpenPdf] = useState(false);

  return (
    <Form form={form1} layout='vertical' initialValues={{ status: true, visibleToDealer: true }}>
      <div style={{ paddingBottom: "10px" }}>
        <span
          className='card-label font-weight-bolder text-dark'
          style={{ fontSize: 20, fontWeight: "bold" }}
        >
          รายละเอียดข้อมูลส่วนลด
        </span>
      </div>
      <br />
      <Row justify={"space-around"} gutter={8}>
        <Col span={12}>
          <Form.Item
            label='ชื่อรายการ'
            name='name'
            rules={[{ required: true, message: "โปรดระบุชื่อรายการ" }]}
            required
          >
            <Input placeholder='ระบุชื่อรายการ' autoComplete='off' />
          </Form.Item>
        </Col>
        <Col span={12}>
          <Form.Item
            label='ประเภทส่วนลด'
            name='creditMemoTypeId'
            rules={[{ required: true, message: "โปรดระบุประเภทส่วนลด" }]}
            required
          >
            <Select
              style={{ height: "40px" }}
              options={
                typeList.map((type) => ({
                  label: `${type.code} • ${type.nameTh}`,
                  value: type.creditMemoTypeId,
                  key: type.creditMemoTypeId,
                })) || []
              }
              placeholder='เลือกประเภทส่วนลด'
              labelRender={({ value }) => {
                const option: any = typeList.find((x) => x.creditMemoTypeId === value);
                return (
                  <Tag
                    color={option?.color}
                    style={{ backgroundColor: `${option?.color}20`, borderRadius: "4px" }}
                  >
                    <Typography.Text
                      style={{
                        color: option?.color,
                        fontFamily: "IBM Plex Sans Thai",
                        fontWeight: 600,
                        fontSize: 16,
                      }}
                    >
                      {option?.code} • {option?.nameTh}
                    </Typography.Text>
                  </Tag>
                );
              }}
            />
          </Form.Item>
        </Col>
      </Row>
      <Row align='middle' gutter={16}>
        <Col span={12}>
          <Row gutter={16}>
            <Col span={12}>
              <Form.Item
                name='startDate'
                label='วันที่เริ่มใช้'
                rules={[
                  {
                    required: true,
                    message: "*โปรดเลือกวันที่เริ่มใช้",
                  },
                ]}
              >
                <DatePicker
                  style={{ width: "100%" }}
                  enablePast
                  disabledDate={(current: Dayjs) => {
                    const endDate = form1.getFieldValue("endDate");
                    return current && endDate && current.isAfter(dayjs(endDate));
                  }}
                />
              </Form.Item>
            </Col>
            <Col span={12}>
              <Form.Item
                name='startTime'
                label='เวลาเริ่มใช้'
                initialValue={dayjs("00:00", "HH:mm")}
              >
                <TimePicker allowClear={false} />
              </Form.Item>
            </Col>
          </Row>
        </Col>
        <Col span={12}>
          <Row gutter={16}>
            <Col span={12}>
              <Form.Item
                name='endDate'
                label='วันที่สิ้นสุด'
                rules={[
                  {
                    required: true,
                    message: "*โปรดเลือกวันที่สิ้นสุด",
                  },
                ]}
              >
                <DatePicker
                  style={{ width: "100%" }}
                  disabledDate={(current: Dayjs) => {
                    const startDate = form1.getFieldValue("startDate");
                    return current && current.isBefore(dayjs(startDate));
                  }}
                  enablePast
                />
              </Form.Item>
            </Col>
            <Col span={12}>
              <Form.Item name='endTime' label='เวลาสิ้นสุด' initialValue={dayjs("23:59", "HH:mm")}>
                <TimePicker
                  allowClear={false}
                  disabledTime={(now) => {
                    const startDate = form1.getFieldValue("startDate") as Dayjs;
                    const endDate = form1.getFieldValue("endDate") as Dayjs;
                    const startTime = form1.getFieldValue("startTime") as Dayjs;
                    const isSameDay = startDate && endDate && startDate?.isSame(endDate, "year");
                    if (!isSameDay) return {};

                    const hour = startTime.hour();
                    const minute = startTime.minute();
                    const hours: number[] = [];
                    const minutes: number[] = [];
                    for (let i = 0; i < hour; i++) {
                      hours.push(i);
                    }
                    for (let i = 0; i <= minute; i++) {
                      minutes.push(i);
                    }
                    return {
                      disabledHours: () => hours,
                      disabledMinutes: (selectedHour: number) =>
                        selectedHour === hour ? minutes : [],
                    };
                  }}
                />
              </Form.Item>
            </Col>
          </Row>
        </Col>
      </Row>
      <Row justify={"space-around"} gutter={8}>
        <Col span={24}>
          <Form.Item label='หมายเหตุเพิ่มเติม' name='description'>
            <TextArea
              rows={3}
              placeholder='หมายเหตุใน BO (ไม่แสดงให้ Dealer เห็น)'
              autoComplete='off'
            />
          </Form.Item>
        </Col>
      </Row>
      <Col span={12}>
        <Text fontWeight={600}>ไฟล์แนบ PDF</Text>
        <br />
        <Text color='Text3' level={6}>
          แนบเอกสารอ้างอิงจาก
        </Text>
        <Card bodyStyle={{ padding: 12, backgroundColor: "#F3F6F9" }}>
          <Row gutter={8} justify={"start"}>
            <Col span={4}>
              <Upload
                disabled={fileRef?.length > 0}
                accept='.pdf,application/pdf'
                style={{ width: "100%" }}
                action='https://660d2bd96ddfa2943b33731c.mockapi.io/api/upload'
                onChange={async (info) => {
                  let newFileList = [...info.fileList].slice(-1);
                  newFileList = newFileList.map((file) => {
                    const localFile = file.originFileObj as File | undefined;
                    if (file.response?.url) {
                      file.url = file.response.url;
                    } else if (localFile) {
                      file.url = URL.createObjectURL(localFile);
                    }
                    return file;
                  });
                  setFileRef(newFileList);
                  const selectedFile = newFileList[0]?.originFileObj as File | undefined;
                  if (!selectedFile) return;
                  const base64File = await readFileAsBase64(selectedFile);
                  setFileBase64(base64File);
                }}
                fileList={fileRef}
                beforeUpload={() => false}
                showUploadList={false}
              >
                <Button
                  typeButton={fileRef?.length > 0 ? "disabled" : "primary"}
                  title='เลือกไฟล์'
                  height={40}
                />
              </Upload>
            </Col>
            <Col span={19} style={{ paddingTop: "8px" }}>
              {fileRef?.length > 0 ? (
                <>
                  <Text
                    color='primary'
                    style={{ cursor: "pointer" }}
                    onClick={() => {
                      setOpenPdf(true);
                    }}
                  >
                    {fileRef[0]?.name.length > 30
                      ? `${fileRef[0]?.name.slice(0, 30)}...pdf`
                      : fileRef[0]?.name}
                  </Text>
                  {openPdf && (
                    <ModalPreviewFile
                      openPdf={openPdf}
                      setOpenPdf={setOpenPdf}
                      fileRef={fileBase64 || fileRef[0]?.url}
                    />
                  )}
                </>
              ) : (
                <>
                  <Col>
                    <img
                      src={icon.icon_pdf}
                      alt='PDF Icon'
                      style={{ width: "22px", height: "26px" }}
                    />{" "}
                    <Text level={6} color='Text3'>
                      โปรดเลือกไฟล์ .PDF
                    </Text>
                  </Col>
                </>
              )}
            </Col>
            {fileRef?.length > 0 && (
              <Col style={{ paddingTop: "8px" }}>
                <DeleteFilled
                  style={{ color: color.error }}
                  onClick={() => {
                    setFileRef([]);
                    setFileBase64(null);
                  }}
                />
              </Col>
            )}
          </Row>
        </Card>
      </Col>
      <br />
      <Card style={{ width: "100%", backgroundColor: "#FAFAFA" }}>
        <div style={{ paddingBottom: "10px" }}>
          <Text level={5} fontWeight={600}>
            วิธีคิดส่วนลด (Limit Mode) <Text color='error'>*</Text>
          </Text>
          <br />
          <Text color='Text3' level={6}>
            วิธีคิดส่วนลดของรายการนี้ (หากสร้างแล้วจะไม่สามารถเปลี่ยนวิธีคิดส่วนลดได้ภายหลัง)
          </Text>
        </div>
        <Form.Item
          name='type'
          rules={[
            {
              required: true,
              message: "*โปรดเลือกวิธีคิดส่วนลด",
            },
          ]}
        >
          <Radio.Group
            className='mode-radio-group'
            onChange={() => form2.resetFields()}
            disabled={form1?.getFieldValue("coId") ? true : false}
          >
            <Radio value='BILL_PCT'>
              <Flex vertical>
                <Text fontWeight={600} level={6}>
                  % ของยอดบิล
                </Text>
                <Text color='Text3' level={6}>
                  ระบุ % ต่อร้านใน ขั้นตอนที่ 2
                </Text>
              </Flex>
            </Radio>
            <Radio value='SKU'>
              <Flex vertical>
                <Text fontWeight={600} level={6}>
                  บาท (฿) / หน่วย
                </Text>
                <Text color='Text3' level={6}>
                  ระบุ บาท (฿) ต่อหน่วย x จำนวนหน่วยสินค้าใน ขั้นตอนที่ 2
                  <br />
                  ระบุยอดส่วนลดต่อร้านใน ขั้นตอนที่ 3
                </Text>
              </Flex>
            </Radio>
          </Radio.Group>
        </Form.Item>
      </Card>
      <br />

      <Row justify={"space-between"} gutter={16}>
        {!form1.getFieldValue("coId") && (
          <Col span={12}>
            <Card style={{ backgroundColor: "#FAFAFA" }}>
              <Row justify={"start"} gutter={8}>
                <Col>
                  <Form.Item name='status'>
                    <Switch />
                  </Form.Item>
                </Col>
                <Col>
                  <Text>เปิดใช้งานรายการส่วนลด</Text>
                  <br />
                  <Text color='Text3' level={6}>
                    สามารถเปิด/ปิดรายร้านได้ในขั้นตอนการเลือกร้านค้า
                  </Text>
                </Col>
              </Row>
            </Card>
          </Col>
        )}
        <Col span={12}>
          <Card style={{ backgroundColor: "#FAFAFA" }}>
            <Row justify={"start"} gutter={8}>
              <Col>
                <Form.Item name='visibleToDealer'>
                  <Switch />
                </Form.Item>
              </Col>
              <Col>
                <Text>แสดงให้ Dealer เห็นใน Shop App</Text>
                <br />
                <Text color='Text3' level={6}>
                  กรณีปิด SaleCo เห็น แต่ Dealer จะไม่เห็นใน Shop App
                </Text>
              </Col>
            </Row>
          </Card>
        </Col>
      </Row>
    </Form>
  );
};
